import { Icon, IconProps } from '@chakra-ui/react'

export default function StarManagerIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.15408 13.8897C4.81603 14.0661 4.40707 14.035 4.09956 13.8095C3.79204 13.584 3.63947 13.2033 3.70614 12.8279L4.2457 9.73526L1.97409 7.55836C1.69642 7.29356 1.59466 6.89329 1.71215 6.52803C1.82964 6.16278 2.14568 5.8969 2.52565 5.84364L5.67963 5.39279L7.10356 2.55227C7.27239 2.21161 7.61973 1.99609 7.99993 1.99609C8.38013 1.99609 8.72747 2.21161 8.8963 2.55227L10.3202 5.39279L13.4742 5.84364C13.8542 5.8969 14.1702 6.16278 14.2877 6.52803C14.4052 6.89329 14.3034 7.29356 14.0258 7.55836L11.7542 9.73526L12.2937 12.8286C12.3604 13.204 12.2078 13.5847 11.9003 13.8102C11.5928 14.0357 11.1838 14.0668 10.8458 13.8903L7.99993 12.4197L5.15408 13.8897Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
